import React from "react";
import { Visibility } from "semantic-ui-react";
import ResponsiveBackgroundContainer from "./ResponsiveBackgroundContainer";
import WorkflowSection from "./WorkflowSection";
import content from "./content";

const Workflow = props => (
  <div>
    <Visibility {...props} once={false}>
      <ResponsiveBackgroundContainer className="section is-medium has-text-light">
        <div className="container">
          <div className="columns">
            <div className="column is-offset-8-desktop is-4-desktop is-12-touch">
              <h1 className="title is-3 has-text-light">Workflow</h1>
              <p>
                A brief overview of the evolution of a sealed connector, from
                order to finished part.
              </p>
            </div>
          </div>
        </div>
      </ResponsiveBackgroundContainer>
    </Visibility>
    <WorkflowSection
      title="Glass-to-Metal Hermetic Seals"
      subtitle="Example Workflow"
      content={content.glassSeals}
    />
    <hr />
    <WorkflowSection
      title="Precision CNC Machined Parts"
      subtitle="Example Workflow"
      content={content.precisionCNC}
    />
  </div>
);

export default Workflow;



// WEBPACK FOOTER //
// ./src/pages/Workflow/Workflow.js